import {
  createFileRoute,
  Outlet,
  useMatches,
  useNavigate,
} from '@tanstack/react-router';
import { Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Page,
  PageContent,
  PageHeader,
  PageHeaderDescription,
  PageHeaderInfo,
  PageHeaderTitle,
} from '@/components/ui/layout/page';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const Route = createFileRoute('/_authenticated/user/edit')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const matches = useMatches();
  const activeTab = matches.some((match) =>
    match.pathname.includes('edit/security')
  )
    ? 'security'
    : 'account';

  return (
    <Page>
      <PageHeader>
        <PageHeaderInfo>
          <PageHeaderTitle>
            {t('authenticated.user.edit.title')}
          </PageHeaderTitle>
          <PageHeaderDescription>
            {t('authenticated.user.edit.description')}
          </PageHeaderDescription>
        </PageHeaderInfo>
      </PageHeader>

      <PageContent>
        <Tabs value={activeTab} className="space-y-6">
          <TabsList>
            {/* <TabsTrigger
              value="account"
              className="px-6 flex items-center group"
              onClick={() => navigate({ to: '/user/edit/account' })}
            >
              <User className="h-5 w-5 mr-2 group-data-[state=active]:text-blue-500" />
              Account
            </TabsTrigger> */}
            <TabsTrigger
              value="security"
              className="px-6 flex items-center group"
              onClick={() => navigate({ to: '/user/edit/security' })}
            >
              <Shield className="h-5 w-5 mr-2 group-data-[state=active]:text-green-500" />
              {t('authenticated.user.edit.tabs.security')}
            </TabsTrigger>
          </TabsList>

          <Outlet />
        </Tabs>
      </PageContent>
    </Page>
  );
}
